import React from 'react';
import { User } from '../../models/User';
import { BodyCard } from 'Common/components/Molecules/BodyCard';
import { Button } from 'Common/components/Atoms/Button';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { useTheme } from '@mui/material/styles';
import { PageContainer } from 'Common/components/Templates/PageContainer';
import { Text } from 'Common/components/Atoms/Text';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  user: User;
}

function ReviewerDashboard(props: Props) {
  const { user } = props;
  const theme = useTheme();

  return (
    <PageContainer>
      <Text variant="h2" textAlign="center" my={5}>
        You're all set, {user.name}!
      </Text>
      <BodyCard width={400} mx="auto">
        <Text variant="body1" textAlign="center">
          You're all set!
        </Text>
        <Flex justifyContent="center" alignItems="center" my={6}>
          <Flex borderRadius="50%" p={4} background={theme.palette.success.dim}>
            <FontIcon
              icon={faCheck}
              size="5x"
              color={theme.palette.success.main}
              display="block"
              mx="auto"
            />
          </Flex>
        </Flex>
        <Text variant="body1" textAlign="center" my={6}>
          You've been fully onboarded as a reviewer in the PullRequest Reviewer
          Network.
        </Text>
        <Button
          href={process.env.REACT_APP_REVIEWER_URL}
          variant="contained"
          width="100%"
          color="secondary"
        >
          Click here to start reviewing code
        </Button>
      </BodyCard>
    </PageContainer>
  );
}

export default ReviewerDashboard;
